import React from 'react';
import AboutImage from './AboutImage';
import { Eye, Gem } from 'lucide-react';
import './about.css';

const AboutVisionValuesSection = ({ data }) => {
    if (!data) return null;

    const valuesItems = data.valuesItems || [];

    return (
        <section className="w-full bg-white py-10 lg:py-14 about-section-divider">
            <div className="about-shell">
                <h2 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight mb-6">
                    {data.visionValuesSectionTitle || 'TẦM NHÌN & GIÁ TRỊ'}
                </h2>

                <div className="about-vision-values-grid">
                    {/* Cột trái: Tầm nhìn */}
                    <div className="flex flex-col min-w-0">
                        <div className="flex items-center gap-2 mb-3">
                            <Eye size={20} className="text-[#E31E24] shrink-0" strokeWidth={2.5} />
                            <h3 className="text-lg md:text-xl font-black text-[#E31E24] uppercase tracking-tight">
                                {data.visionTitle || 'TẦM NHÌN'}
                            </h3>
                        </div>

                        <p className="text-slate-700 text-sm md:text-[14.5px] leading-relaxed text-justify mb-5">
                            {data.visionContent}
                        </p>

                        <div className="about-media-box about-media-box--vision mt-auto">
                            <AboutImage
                                src={data.visionImage}
                                fallback="/assets/images/hethong.jpg"
                                alt={data.visionTitle || 'Tầm nhìn'}
                                variant="banner"
                            />
                        </div>
                    </div>

                    {/* Cột phải: Giá trị cốt lõi */}
                    <div className="flex flex-col min-w-0">
                        <div className="flex items-center gap-2 mb-6">
                            <Gem size={20} className="text-[#E31E24] shrink-0" strokeWidth={2.5} />
                            <h3 className="text-lg md:text-xl font-black text-[#E31E24] uppercase tracking-tight">
                                {data.valuesTitle || 'GIÁ TRỊ CỐT LÕI'}
                            </h3>
                        </div>

                        {valuesItems.length > 0 && (
                            <div className="w-full overflow-x-auto pb-2">
                                <div className="min-w-[480px] grid grid-cols-5 gap-2 md:gap-3">
                                    {valuesItems.map((item, i) => (
                                        <div key={`value-${i}-${item.title}`} className="text-center flex flex-col items-center min-w-0">
                                            <div className="about-icon-circle">
                                                <AboutImage
                                                    src={item.iconUrl}
                                                    fallback={`/assets/images/icon-dv-${(i % 3) + 1}.png`}
                                                    alt={item.title || ''}
                                                    variant="icon"
                                                    className="about-icon-white"
                                                />
                                            </div>
                                            {item.title && (
                                                <h4 className="text-[11px] md:text-xs font-black text-slate-900 uppercase mb-1 leading-tight text-center">
                                                    {item.title}
                                                </h4>
                                            )}
                                            {item.description && (
                                                <p className="text-[10px] md:text-[11px] text-slate-500 leading-tight text-center">
                                                    {item.description}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutVisionValuesSection;
